import { defineStore } from 'pinia';

import { CookieEnum, ParamEnum } from '@interface/public';
import Config from '@constant/config';
import FN from '@constant/function';

export interface UserStateInterface { // 用户状态
  token: string; // 会话
  userID: string; // 用户标识
  username: string; // 用户名
  source: string; // 源地址
  sourceAccess: string; // 访问源地址
  operate: string; // 操作
  invite: string; // 邀请
  bdVid: string; // 百度推广
  isHideMsg: string;
}

const urlHref = location.href,
  urlHash = location.hash.split('#')[1],
  urlParam = {
    token: FN.Url.get(ParamEnum.Token, urlHref) || FN.Url.get(ParamEnum.Token, urlHash) || FN.Cookie.get(CookieEnum.Token) || '',
    userID: FN.Url.get(ParamEnum.UserID, urlHref) || FN.Url.get(ParamEnum.UserID, urlHash) || FN.Cookie.get(CookieEnum.UserID) || '',
    username: FN.Url.get(ParamEnum.UserName, urlHref) || FN.Url.get(ParamEnum.UserName, urlHash) || FN.Cookie.get(CookieEnum.UserName) || '',
    source: FN.Url.get(ParamEnum.Source, urlHref) || FN.Url.get(ParamEnum.Source, urlHash) || FN.Cookie.get(CookieEnum.Source) || '',
    sourceAccess: decodeURIComponent(FN.Url.get(ParamEnum.SourceAccess, urlHref) || FN.Url.get(ParamEnum.SourceAccess, urlHash) || FN.Cookie.get(CookieEnum.SourceAccess) || ''),
    operate: FN.Url.get(ParamEnum.Operate, urlHref) || FN.Url.get(ParamEnum.Operate, urlHash) || '',
    invite: FN.Url.get(ParamEnum.Invite, urlHref) || FN.Url.get(ParamEnum.Invite, urlHash) || FN.Cookie.get(CookieEnum.Invite) || '',
    bdVid: FN.Url.get(ParamEnum.BdVid, urlHref) || FN.Url.get(ParamEnum.BdVid, urlHash) || FN.Cookie.get(CookieEnum.BdVid) || '',
    isHideMsg: FN.Url.get('isHideMsg', urlHref) || FN.Url.get('isHideMsg', urlHash) || ''
  };

FN.Cookie.set({
  [CookieEnum.Token]: urlParam.token,
  [CookieEnum.UserID]: urlParam.userID,
  [CookieEnum.UserName]: urlParam.username,
  [CookieEnum.Source]: urlParam.source,
  [CookieEnum.SourceAccess]: urlParam.sourceAccess,
  [CookieEnum.Invite]: urlParam.invite,
  [CookieEnum.BdVid]: urlParam.bdVid
}, Config.Cookie.time, '/', Config.Cookie.domain);
history.replaceState(null, null, FN.Url.del(Object.keys(FN.Url.all(urlHref)), urlHref));

/**
 * 用户数据
 */
export default defineStore('user', {
  state: (): UserStateInterface => { // 状态
    return {
      token: urlParam.token || '',
      userID: urlParam.userID || '',
      username: urlParam.username || '',
      source: urlParam.source || '',
      sourceAccess: urlParam.sourceAccess || '',
      operate: urlParam.operate || '',
      invite: urlParam.invite || '',
      bdVid: urlParam.bdVid || '',
      isHideMsg: urlParam.isHideMsg || ''
    };
  },
  getters: { // 获取
  },
  actions: { // 方法
    /**
     * 过滤链接
     */
    async filterLink(): Promise<any> {
      await $Application.Router.replace({
        path: $ENV.isProduction ? location.pathname : urlHash.split('?')[0],
        query: $Lodash.omit($FN.Url.all(urlHref), [
          String([ $Enum.ParamEnum.Token ]),
          String([ $Enum.ParamEnum.UserID ]),
          String([ $Enum.ParamEnum.UserName ])
        ])
      });
    },
    
    /**
     * 更新信息
     * @param {*} data 数据
     */
    updateInfo(data: any): void {
      $FN.Object.synchronize(this, data);
      
      $FN.Cookie.set({
        [$Enum.CookieEnum.Token]: this.token,
        [$Enum.CookieEnum.UserID]: this.userID,
        [$Enum.CookieEnum.UserName]: this.username,
        [$Enum.CookieEnum.Source]: this.source,
        [$Enum.CookieEnum.SourceAccess]: this.sourceAccess
      }, $Config.Cookie.time, '/', $Config.Cookie.domain);
    },
    
    /**
     * 清理信息
     */
    clearInfo(): void {
      $FN.Object.synchronize(this, {
        token: '',
        userID: '',
        username: ''
      });
      
      $FN.Cookie.del([
        $Enum.CookieEnum.Token,
        $Enum.CookieEnum.UserID,
        $Enum.CookieEnum.UserName
      ], '/', $Config.Cookie.domain);
    },
    
    
    /**
     * 清理源
     */
    clearSource(): void {
      $FN.Object.synchronize(this, {
        source: '',
        sourceAccess: ''
      });
      
      $FN.Cookie.del([
        $Enum.CookieEnum.Source,
        $Enum.CookieEnum.SourceAccess
      ], '/', $Config.Cookie.domain);
    },
    
    /**
     * 清理操作
     */
    clearOperate(): void {
      $FN.Object.synchronize(this, {
        operate: ''
      });
    }
  }
});